<template>
  <div>
    <vault-import-stepper>
    </vault-import-stepper>

    <vault-import-connection v-if="step === 1">
    </vault-import-connection>

    <vault-import-documents v-if="step === 2">
    </vault-import-documents>

    <vault-import-permissions v-if="step === 3">
    </vault-import-permissions>

    <vault-import-folders v-if="step === 4">
    </vault-import-folders>

    <vault-import-review v-if="step === 5">
    </vault-import-review>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import VaultImportStepper from './components/Stepper';
import VaultImportDocuments from './Documents';
import VaultImportFolders from './Folders';
import VaultImportReview from './Review';
import VaultImportPermissions from './Permissions';
import VaultImportConnection from './Connection';

export default {
  components: {VaultImportConnection, VaultImportPermissions, VaultImportReview, VaultImportFolders, VaultImportDocuments, VaultImportStepper},
  computed: {
    ...mapGetters([
      'team',
    ]),
    ...mapGetters('vaultCart', [
      'step',
    ])
  },
  created() {
    this.$store.dispatch('veevaVault/initStore');
    this.$store.dispatch('vaultCart/reset');
    //this.$store.dispatch('vaultCart/setConnection', this.team.vault_connection_id);
  }
}
</script>
